export default __webpack_public_path__ + "static/media/peas.ea8f96c7.png";